export const getConceptCode = (): string => 
{
    const concept_Code = (document.getElementById('conceptCode') as HTMLInputElement)?.value || 'MRE';
    return concept_Code;
}